import type { DataTableProviderFilterStateValue } from './types';

/** Stable string for React deps / remount keys when applied filter *content* changes. */
export function appliedFiltersFingerprint(
  filters: Map<string, DataTableProviderFilterStateValue>
): string {
  try {
    return JSON.stringify(
      [...filters.entries()]
        .filter(([, v]) => v?.value !== '' && v?.value != null)
        .sort(([a], [b]) => String(a).localeCompare(String(b)))
        .map(([k, v]) => [k, v.value, v.label])
    );
  } catch {
    return '';
  }
}
